// extracted by mini-css-extract-plugin
export var attachment = "_qg-a";
export var emailContainer = "_qg-4";
export var emailContentPaddedContainer = "_qg-b";
export var emailHeader = "_qg-6";
export var emailIframe = "_qg-3";
export var emailInfoIcon = "_qg-9";
export var emailShortenedSummary = "_qg-e";
export var infoDropdown = "_qg-0";
export var infoRowBoundedContent = "_qg-d";
export var internal = "_qg-5";
export var merchant = "_qg-8";
export var messageInputContainer = "_qg-h";
export var normal = "_qg-7";
export var replyCard = "_qg-f";
export var subtleButton = "_qg-1";
export var subtleButtonIconContainer = "_qg-2";
export var toggleViewRepliesButton = "_qg-c";
export var wrappingText = "_qg-g";